import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { setColor, setFont } from "../../../assets/styles/styles";
import ExitIcon from "../../../assets/images/icons/x2.svg";
import Chevron from "../../../assets/images/icons/Chevron.svg";
import IntraverseMiniLogoIcon from "../../../assets/images/logos/pink_intraverse_logo.svg";

const ResetPasswordPopUp = ({ onClose }) => {
    const navigate = useNavigate();

    const handleResetPassword = () => {
        navigate("/reset-password");
    };
    return (
        <>
            <ModalContainer>
                <Container>
                    <MobileHeader>
                        <MobileLogo src={IntraverseMiniLogoIcon} alt="Intraverse Logo" />
                    </MobileHeader>

                    <CloseIcon onClick={onClose} />

                    <Title>Can’t sign in?</Title>
                    <SignInText>
                        Looks like you’re having trouble signing in! Do you want reset your password?
                    </SignInText>
                    <ResetButton onClick={handleResetPassword}>
                        <ResetButtonText>Reset Password</ResetButtonText>
                    </ResetButton>
                    <ExitText onClick={onClose}>No Thanks</ExitText>
                </Container>
            </ModalContainer>
        </>
    );
};
const ModalContainer = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
`;

const Container = styled.div`
    position: relative;
    border-radius: 10px;
    border: 4px solid #24242f;
    background: var(--Black-Primary, #1b1b23);
    padding: 20px;
    width: 700px;
    height: 404px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: 768px) {
        width: 100%;
        height: 100%;
        border-radius: 0;
        border: none;
    }
`;

const MobileHeader = styled.div`
    display: none;
    @media (max-width: 768px) {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 75px;
        flex-shrink: 0;
        background: #000;
        z-index: 1000;
        align-items: center;
        justify-content: center;
    }
`;

const MobileLogo = styled.img`
    display: none;
    @media (max-width: 768px) {
        display: block;
        width: 51px;
        height: 51px;
    }
`;

const CloseIcon = styled.div`
    position: absolute;
    top: 15px;
    right: 10px;
    width: 40px;
    height: 40px;
    background-image: url(${ExitIcon});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    flex-shrink: 0;

    @media (max-width: 768px) {
        transform: rotate(90deg);
        top: 25px;
        left: 20px;
        background-image: url(${Chevron});
        width: 20px;
        height: 20px;
        z-index: 1000;
    }
`;

const Title = styled.h2`
    color: ${setColor.accent4};
    font-family: ${setFont.barlowCondensed};
    font-size: 50px;
    font-weight: 700;
    text-transform: uppercase;
    margin-top: 40px;
    margin-bottom: 30px;
    @media (max-width: 768px) {
        padding-top: 50px;
    }
`;

const SignInText = styled.p`
    width: 600px;
    color: ${setColor.iconColor};
    text-align: center;
    font-family: ${setFont.barlow};
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 50px;
    @media (max-width: 768px) {
        width: 100%;
        max-width: 480px;
    }
`;

const ResetButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 600px;
    padding: 15px;
    border-radius: 5px;
    background: ${setColor.pinkButtonBgGradient};
    cursor: pointer;
    margin-bottom: 30px;
    border: none;
    outline: none;

    @media (max-width: 768px) {
        margin-top: auto;
    }
`;

const ResetButtonText = styled.p`
    color: ${setColor.inputText};
    font-family: "Barlow";
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
`;

const ExitText = styled.p`
    color: ${setColor.iconColor};
    font-family: "Barlow";
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    margin-bottom: 50px;
    @media (max-width: 768px) {
        display: none;
    }
`;

export default ResetPasswordPopUp;
